import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { okResponse } from '../../routes/defaultResponses';
import { makeNullable } from '../../utils/typeboxHelpers';
import { surveyPointCloudTableSchema } from './surveyPointCloudTableSchema';

export const surveyPointCloudPaths = {
    '/api/surveys/{surveyId}/pointClouds/{surveyPointCloudId}': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('surveyPointCloudId')],
        post: {
            operationId: 'surveyPointCloudController.update',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            display: Type.Optional(Type.String()),
                            isVisible: Type.Optional(Type.Boolean()),
                            filename: Type.Optional(Type.String()),
                            startTemperatureRange: Type.Optional(makeNullable(Type.Number())),
                            endTemperatureRange: Type.Optional(makeNullable(Type.Number())),
                        }),
                    },
                },
            },
            responses: { ...okResponse },
        },
        delete: {
            operationId: 'surveyPointCloudController.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
        get: {
            operationId: 'surveyPointCloudController.getOne',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Optional(
                                Type.Intersect([
                                    Type.Object({
                                        id: Type.String(),
                                    }),
                                    Type.Object({
                                        filename: Type.String(),
                                    }),
                                    Type.Object({
                                        storageId: Type.String(),
                                    }),
                                    Type.Object({
                                        isVisible: Type.Boolean(),
                                    }),
                                    Type.Object({
                                        display: Type.String(),
                                    }),
                                ]),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/pointClouds': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'surveyPointCloudController.getAllForSurvey',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Pick(surveyPointCloudTableSchema, [
                                    'id',
                                    'filename',
                                    'storageId',
                                    'isVisible',
                                    'display',
                                    'startTemperatureRange',
                                    'endTemperatureRange',
                                ]),
                            ),
                        },
                    },
                },
            },
        },
    },
} as const;
